module.exports = __webpack_public_path__ + "static/img/goods-666.a2db19d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s28/pop/goods-666.png
// module id = P3Wp
// module chunks = 2